export default "__VITE_ASSET__DgI_ySCT__"